<div nxModalContent class="insured-import__wrapper">
  <h3 nxHeadline="subsection-medium" class="nx-margin-bottom-m">
    {{ 'modals.insured-import.title' | translate }}
  </h3>

  <p nxCopytext="normal" [innerHTML]="'modals.insured-import.description1' | translate | markdown" class="insured-import__description"></p>
  <a nxCopytext="normal" class="md-link nx-margin-left-3xs" href="assets/import_osob_wzor.xlsx" download
    ><b>{{ 'modals.insured-import.download' | translate }}</b></a
  >
  <p nxCopytext="normal" [innerHTML]="'modals.insured-import.description2' | translate | markdown"></p>

  <form [formGroup]="insuredImportForm">
    <div class="insured-import__file-upload-wrapper nx-margin-top-l">
      <p nxCopytext="normal" class="nx-margin-bottom-2xs">
        <b>
          {{ 'modals.insured-import.file-upload.headline' | translate }}
        </b>
      </p>
      <p nxCopytext="normal" class="nx-margin-bottom-2xs">
        {{'modals.insured-import.file-upload.upload-instruction' | translate}}
      </p>
      <ul nxList="small" class="nx-margin-bottom-xs">
        <li>{{'modals.insured-import.file-upload.upload-instruction-condition-1' | translate}}</li>
        <li>{{'modals.insured-import.file-upload.upload-instruction-condition-2' | translate}}</li>
        <li>{{'modals.insured-import.file-upload.upload-instruction-condition-3' | translate}}</li>
      </ul>
      <p nxCopytext="medium" class="nx-margin-bottom-s nx-font-weight-light">
        {{ 'modals.insured-import.file-upload.file-description' | translate }}
      </p>

      <nx-file-uploader
        formControlName="document"
        (filesSelected)="onFilesAddedChange($event)"
        (fileDeleted)="onFileDelete()"
        [maxFileSize]="maxFileSize"
        #documentUpload
      >
        <button nxButton="primary" type="button" class="nx-margin-bottom-s" nxFileUploadButton>
          <nx-icon name="plus" class="nx-margin-right-2xs"></nx-icon>
          {{ 'modals.insured-import.file-upload.button-upload-file' | translate }}
        </button>
      </nx-file-uploader>
    </div>

    <nx-message
      *ngIf="correctRecords?.length && !errorRecords?.length && (insuredImportState$ | async) === apiState.success"
      context="success"
    >
      {{ 'modals.insured-import.file-upload.upload-success' | translate }}
    </nx-message>

    <nx-message *ngIf="errorMessage" context="error">
      {{ errorMessage }} {{ 'modals.insured-import.file-upload.upload-error' | translate }}
    </nx-message>

    <nx-message *ngIf="(insuredImportState$ | async) === apiState.error" context="error">
      {{ 'modals.insured-import.file-upload.upload-server-error' | translate }}
    </nx-message>

    <nx-message *ngIf="insuredImportForm.controls['document'].hasError('NxFileUploadMaxFileSize')" context="error">
      {{ 'modals.insured-import.file-upload.size-limit' | translate }}
    </nx-message>
  </form>

  <table nxTable *ngIf="(insuredImportState$ | async) === apiState.success" class="insured-import__records-count-table nx-margin-top-m">
    <tbody>
      <tr *ngIf="recordsLength" nxTableRow>
        <td nxTableCell>
          <p nxCopytext="normal">{{ 'modals.insured-import.import.records' | translate }}</p>
        </td>
        <td nxTableCell>{{ recordsLength }}</td>
      </tr>
      <tr *ngIf="correctRecords && correctRecords.length > 0" nxTableRow>
        <td nxTableCell>
          <p nxCopytext="normal">{{ 'modals.insured-import.import.records-correct' | translate }}</p>
        </td>
        <td nxTableCell>{{ correctRecords.length }}</td>
      </tr>
      <tr *ngIf="errorRecords" nxTableRow>
        <td nxTableCell>
          <p nxCopytext="normal">{{ 'modals.insured-import.import.records-incorrect' | translate }}</p>
          <button *ngIf="errorRecords?.length" nxPlainButton class="nx-margin-left-2xs" (click)="openErrorsModal()">
            {{ 'modals.insured-import.import.records-incorrect-check' | translate }}
          </button>
        </td>
        <td nxTableCell>{{ errorRecords.length }}</td>
      </tr>
      <tr *ngIf="errorGlobal" nxTableRow>
        <td nxTableCell>
          <p nxCopytext="normal">{{ 'modals.insured-import.import.errors-incorrect' | translate }}</p>
          <button *ngIf="errorGlobal.length" nxPlainButton class="nx-margin-left-2xs" (click)="openGlobalErrorsModal()">
            {{ 'modals.insured-import.import.records-incorrect-check' | translate }}
          </button>
        </td>
        <td nxTableCell>{{ errorGlobal.length }}</td>
      </tr>
    </tbody>
  </table>

  <div class="insured-import__buttons-wrap nx-margin-top-l">
    <button nxButton="secondary" (click)="closeInsuredImportModal()" class="nx-margin-right-m">
      {{ 'modals.insured-import.cancel' | translate }}
    </button>
    <button
      *ngIf="(insuredImportState$ | async) !== apiState.idle"
      [disabled]="
        !!errorRecords?.length ||
        !!errorGlobal?.length ||
        (insuredImportState$ | async) === apiState.error ||
        (insuredImportState$ | async) === apiState.pending
      "
      nxButton="primary"
      (click)="importData()"
    >
      {{ 'modals.insured-import.import.start-import' | translate }}
    </button>
  </div>

  <ng-template #errorsModal>
    <div nxModalContent class="insured-import__errors-modal">
      <h3 nxHeadline="subsection-medium" class="nx-margin-bottom-m insured-import__errors-modal-headline">
        {{ 'modals.insured-import.errors-list.title' | translate }}
      </h3>
      <div class="scroll-container">
        <table nxTable *ngIf="recordsLength" class="nx-table--scrollable nx-margin-top-m">
          <thead>
            <tr nxTableRow>
              <th nxHeaderCell>{{ 'modals.insured-import.errors-list.row' | translate }}</th>
              <th nxHeaderCell>{{ 'modals.insured-import.errors-list.error' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr nxTableRow *ngFor="let item of errorRecords">
              <td nxTableCell>
                {{ item.index }}
              </td>
              <td nxTableCell *ngIf="item.errors">{{ getErrorMessage(item.errors) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="insured-import__errors-modal-button-wrap">
        <button nxButton="primary" (click)="closeErrorsModal()" class="nx-margin-top-l">
          {{ 'modals.insured-import.errors-list.close' | translate }}
        </button>
      </div>
    </div>
  </ng-template>
  <ng-template #globalErrorsModal>
    <div nxModalContent class="insured-import__errors-modal">
      <h3 nxHeadline="subsection-medium" class="nx-margin-bottom-m insured-import__errors-modal-headline">
        {{ 'modals.insured-import.errors-list.title' | translate }}
      </h3>
      <div class="scroll-container">
        <table nxTable *ngIf="errorGlobal && errorGlobal.length > 0" class="nx-table--scrollable nx-margin-top-m">
          <thead>
            <tr nxTableRow>
              <th nxHeaderCell>{{ 'modals.insured-import.errors-list.error' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr nxTableRow *ngFor="let item of errorGlobal">
              <td nxTableCell *ngIf="item.message">
                {{ item.message }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="insured-import__errors-modal-button-wrap">
        <button nxButton="primary" (click)="closeGlobalErrorsModal()" class="nx-margin-top-l">
          {{ 'modals.insured-import.errors-list.close' | translate }}
        </button>
      </div>
    </div>
  </ng-template>
</div>
